import _ from 'lodash';
// import Emitter from '../emitter';
import { mscratch } from './index';
import { getTargetDevices } from './ext';
import CONSTANT from '../../constant';

/**
 * 重新已经连接了的设备的连接状态
 * 
 */
export const resetConnectedState = (device, type) => {
    const devices = getTargetDevices(device.deviceId || CONSTANT.DEVICE.CODEY);
    if (!_.isEmpty(devices) && _.isArray(devices)) {
        const device = devices[0];
        const data = {
            id: device.deviceId,
            name: device.name
        };
        connectState(data, true, type);
        return data;
    }
};

/**
 * 设置连接状态
 * 
 * @param {any} device 
 * @param {any} status 是否连接
 */
export const connectState = (device, status, type) => {
    mscratch.connection.setState(device, status, type);
};

/**
 * 设置设备固件状态
 * 
 * @param {any} device 
 * @param {any} status 是否需要更新
 */
export const firmwareState = (device, status) => {
    // console.log({ firmwareState: { device, status } });
    // mscratch.connection.setFirmwareState(device, status);  //跟锦宏了解是历史遗留问题，现在不需要了，注释掉
};